import { useEffect, useState } from "react";

/**
 * Holds a value still until it stops changing.
 *
 * Address lookups are billed per request, so firing one per keystroke turns a
 * ten-character street name into ten charges and ten chances to rate-limit the
 * whole platform. 400ms is long enough to swallow typing and short enough that
 * the list feels like it is keeping up.
 */
export function useDebouncedValue<T>(value: T, delayMs = 400): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
